import type { Resolver } from '~/models/resolver';
import { Common } from '~/models/common';

export namespace FooterMenu {
	export const collection = 'footer_menu';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		title: string | null;
		to: Pick<Resolver.Model, 'url'>;
	};

	export const modelState: Model = {
		...Common.modelState,
		id: 0,
		title: null,
		to: {
			url: '/',
		},
	};
}
